import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { SimpleField } from "../../../../../components/fields/simpleField.jsx";
import { Button } from "../../../../../components/button.jsx";
import * as zod from "zod";
import { SubmitButton } from "../../../../../components/fields/submitButton.jsx";
import { useResource } from "../../../../../hooks/useResource.js";

export function TeamPage() {
  let [users, setUsers] = useState([]);
  let [invitations, setInvitations] = useState([]);
  let invitationsService = useResource("invitations");
  let usersService = useResource("users");

  useEffect(() => {
    usersService.list().then((users) => setUsers(users));
    invitationsService
      .list()
      .then((invitations) => setInvitations(invitations));
  }, []);

  let { control, handleSubmit, setValue, formState, reset } = useForm({
    resolver: zodResolver(zod.object({ email: zod.string().email() })),
  });

  let invite = (d) => {
    setValue("email", "");
    return invitationsService.create(d).then(() => {
      reset({}, { keepValues: true });
      let alreadyPresent = invitations.find(
        (invitation) => invitation.email === d.email
      );
      if (!alreadyPresent) setInvitations([...invitations, { email: d.email }]);
    });
  };

  let cancel = (id) => {
    return invitationsService.delete(id).then(() => {
      setInvitations(invitations.filter((invitation) => invitation.id !== id));
    });
  };

  return (
    <div className={"flex flex-col gap-3 p-3"}>
      <div className={"flex gap-3 items-center"}>
        {" "}
        <div className={"flex"}>
          <h2 className={"font-bold py-2 flex items-center flex-grow"}>Team</h2>
        </div>
        <form onSubmit={handleSubmit(invite)} className={"flex gap-3"}>
          <SimpleField name={"email"} control={control} />
          <SubmitButton formState={formState}>Invite</SubmitButton>
        </form>
        <div className={"flex-grow"} />
      </div>
      <div className={"flex flex-col gap-3"} style={{ maxWidth: 500 }}>
        <h3 className={"font-bold"}>Users</h3>
        {users.map(({ id, email }) => (
          <div className={"bg-white rounded p-3 flex gap-3 items-center"}>
            {email}
          </div>
        ))}
        {invitations.length > 0 && (
          <>
            <h3 className={"font-bold"}>Invitations</h3>
            {invitations.map(({ id, email }) => (
              <div className={"bg-white rounded p-3 flex gap-3 items-center"}>
                {email}
                <Button sizing={"s"} onClick={() => invite({ email })}>
                  Reinvite
                </Button>
                <Button sizing={"s"} onClick={() => cancel(id)}>
                  Cancel
                </Button>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
